import { render, staticRenderFns } from "./AddTraining.vue?vue&type=template&id=16906d8e&scoped=true&"
import script from "./AddTraining.vue?vue&type=script&lang=js&"
export * from "./AddTraining.vue?vue&type=script&lang=js&"
import style0 from "./AddTraining.vue?vue&type=style&index=0&id=16906d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16906d8e",
  null
  
)

export default component.exports